module.exports = __webpack_public_path__ + "static/media/bailey.e014e0e8.png";